<div class="top-action">
  Don't have an account?
  <a class="link" (click)="!loading() && showSignUp()">Sign Up</a>
</div>
<div class="form" [class.loading]="loading()">
  @if (loading()) {
    <div class="loading-overlay">
      <app-loading-spinner/>
    </div>
  }
  <div class="title">
    <p>Sign In</p>
  </div>
  <div class="horizontal-separator"></div>
  <form [formGroup]="form()">
    <div class="f-row">
      <div class="f-group f-group-link">
        <label>Email*</label>
        <div class="f-link" (click)="showMagicLink()">
          Send me a link to sign in
        </div>
        <input
          formControlName="email"
          placeholder="Enter your email address"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('email').touched &&
            form().get('email').invalid
          "
        />
      </div>
    </div>
    <div class="f-row">
      <div class="f-group f-group-link">
        <label>Password*</label>
        <div class="f-link" (click)="showForgotPassword()">
          Forgot your password?
        </div>
        <input
          formControlName="password"
          placeholder="Enter your password"
          class="f-control"
          [type]="passwordVisible() ? 'text' : 'password'"
          [class.error]="
            form() &&
            form().get('password').touched &&
            form().get('password').invalid
          "
        />
        <div class="icon-suffix" (click)="togglePasswordVisibility()">
          @if (passwordVisible()) {
            <i class="fa fa-eye"></i>
          } @else {
            <i class="fa fa-eye-slash"></i>
          }
        </div>
      </div>
    </div>
  </form>
  @if (error()) {
    <div class="message error">
      {{ error() }}
    </div>
  }
</div>
